import { ControlInstance } from "../instance";
class StyleV2Control extends ControlInstance {
  static CHANGE_BOX_MODEL = "makeswift::controls::style::message::change-box-model";
  static CHILD_CONTROL_MESSAGE = "makeswift::controls::style-v2::message::child-control-message";
  control;
  constructor(propDef, sendMessage) {
    super(sendMessage);
    this.control = propDef.createInstance(
      (message) => this.sendMessage({
        type: StyleV2Control.CHILD_CONTROL_MESSAGE,
        payload: { message }
      })
    );
  }
  child(_key) {
    return this.control;
  }
  recv = (message) => {
    switch (message.type) {
      case StyleV2Control.CHILD_CONTROL_MESSAGE: {
        if (this.control == null)
          return;
        this.control.recv(message.payload.message);
      }
    }
  };
  changeBoxModel(boxModel) {
    this.sendMessage({
      type: StyleV2Control.CHANGE_BOX_MODEL,
      payload: { boxModel }
    });
  }
}
export {
  StyleV2Control
};
//# sourceMappingURL=style-v2-control.js.map